import { observer } from 'mobx-react-lite';

import dayjs from 'dayjs';
import { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

const TargetReturnButton = observer(
    ({
        className,
        targetDate,
        targetReturn,
        onChangeTargetReturn,
    }: {
        className?: string;
        targetDate: string;
        targetReturn: 'daily' | 'mtd' | 'ytd';
        onChangeTargetReturn: (target: 'daily' | 'mtd' | 'ytd') => void;
    }) => {
        const targetDateObj = useMemo(() => {
            return dayjs(targetDate);
        }, [targetDate]);

        const defaultButtonClass = 'btn text-base-content/40 rounded-full border';
        const activeButtonClass = 'btn-soft bg-primary/10 text-primary border-primary';

        return (
            <div className={twMerge('flex items-center gap-3', className)}>
                <button
                    className={twMerge(
                        defaultButtonClass,
                        targetReturn === 'daily' && activeButtonClass,
                    )}
                    onClick={() => onChangeTargetReturn('daily')}
                >
                    어제
                </button>
                <button
                    className={twMerge(
                        defaultButtonClass,
                        targetReturn === 'mtd' && activeButtonClass,
                    )}
                    onClick={() => onChangeTargetReturn('mtd')}
                >
                    {targetDateObj.format('M월')}
                </button>
                <button
                    className={twMerge(
                        defaultButtonClass,
                        targetReturn === 'ytd' && activeButtonClass,
                    )}
                    onClick={() => onChangeTargetReturn('ytd')}
                >
                    {targetDateObj.format('YYYY년')}
                </button>
            </div>
        );
    },
);

export default TargetReturnButton;
